export const paths = {
  main: '/',
  p2p: '/p2p',
  transfer: '/transfer',
  transferConfirm: '/transfer/confirm',
  success: '/success',
  error: '/error',
  lookup: '/lookup',
};
